import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { rawRequest, requireConfirmation } from './common.js';

export async function inputCommand(args: ParsedArgs): Promise<CommandResult> {
  const type = args.positionals[1];
  const value = args.positionals[2];
  if (!type || !value)
    throw new CliError('input requires keyboard <keys> or gamepad <buttons>', ExitCode.Usage);
  const method =
    type === 'keyboard'
      ? Methods.InputKeyboard
      : type === 'gamepad'
        ? Methods.InputGamepad
        : undefined;
  if (!method) throw new CliError(`Unknown input type "${type}"`, ExitCode.Usage);
  const params = type === 'keyboard' ? { keys: value } : { buttons: value };
  requireConfirmation(args, `Sending ${type} input requires confirmation`);
  const data = await rawRequest(args, method, params);
  return { data, human: `Sent ${type} input` };
}
